export enum ReminderModelName {
    Lead = 'lead',
    Opportunity = 'opportunity',
    Offer = 'offer',
    Reservation = 'reservation',
    OnlineReservation = 'online_reservation',
    Company = 'company',
    Contact = 'company_contact',
    Invoice = 'invoice',
    AfterSale = 'after_sale',
    Driver = 'driver',
    Seller = 'seller',
}
